<template>
    <div>
        
      <div class="container">
        <div class="crumbs" style="margin-bottom:30px;">
           订单审批流程
          </div>
        <el-form :inline="true" :model="query" ref="query">
          <el-form-item label="审批流程名称" prop="workflowDefinitionName">
            <el-input
              v-model="query.workflowDefinitionName"
              placeholder="审批流程名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建人" prop="createUserName">
            <el-input
              v-model="query.createUserName"
              placeholder="创建人"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="handleClear">重置</el-button>
        </el-form>
      </div>
      <div class="container">
        <div style="margin-bottom: 20px">
          <el-button
            type="primary"
            @click="goToUrl('/orderApproveCreate')"
            style="float: right; margin-bottom: 20px"
            >新增审批流程</el-button
          >
        </div>
  
        <TableList
          :loading="loading"
          :table-data="tableData"
          :table-label="tableLabel"
          :table-option="tableOption"
          :row-key="rowKey"
          @handleButton="handleButton"
        >
          <template v-slot:index="slot">
            {{ slot.scope.$index + 1 }}
          </template>
        </TableList>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="productTagPage.pageNum"
            :page-size="productTagPage.pageSize"
            :total="productTagPage.pageTotal"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TableList from "../../../components/common/e-table-list";
  import CompnanyApi from '../../../api/company/index.js';
  import Api from "../../../api/company/index";
  export default {
    name: "orderApprove",
    components: {
      TableList,
    },
    props: {},
    data () {
      return {
        query: {
          workflowDefinitionName: "",
          createUserName:''
        },
        loading: false,
        tableData: [],
        tableLabel: [
          {
            label: "审批流程名称",
            param: "workflowDefinitionName",
            align: "center",
          },
          { label: "审批流程创建人", param: "createUserName", align: "center" },
          { label: "审批流程创建时间", param: "createTime", align: "center" },
        ],
        rowKey: 'workflowDefinitionId',
        tableOption: {
          label: "操作",
          width: "300",
          fixed: "right",
          permission: '0',
          options: [
            {
              label: "编辑",
              type: "text",
            //   permission: "/transaction-center/workflow/updateWorkflow",
              methods: "handleEdit",
            },
            {
              label: "删除",
              type: "text",
            //   permission: "/transaction-center/workflow/remo",
              methods: "handleDelete",
            },
          ],
        },
        productTagPage: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 0,
        },
        addUserDialogShow: false,
        selectionData: [],
        resetPasswordShow: false,
        dialogTitle: "",
        checkUserShow: false,
        userData: {},
      };
    },
    computed: {},
    watch: {
    },
    created () {
      this.getWorkflowList();
    },
    methods: {
  
      // 查询
      handleSearch () {
        this.productTagPage.pageNum = 1;
        this.productTagPage.pageSize = 10;
        this.getWorkflowList();
      },
      // 重置
      handleClear () {
        this.query.workflowDefinitionName = "";
        this.query.createUserName  = ''
        this.getWorkflowList();
      },
  
      // 删除审批流
      handleDelete (val) {
        if(this.tableData.length == 1){
          this.$confirm("该审批流程将被删除，且审批流启用状态将被关闭，是否继续？", "提示", {
          confirmButtonText: "继续删除",
          cancelButtonText: "取消",
          // type: "warning",
        })
          .then(() => {
            this.handleOrderSwitch();
            this.removeWorkflow(val);//直接删除不提示
          })
          .catch(() => {
            this.$message.info("已取消删除");
          });
        }else{
          this.handleDeleteOk(val);
        }
      },
      // 修改订单审批流 关闭
      async handleOrderSwitch() {
        let res = await CompnanyApi.saveApprovalProcessSwitch({data: '42',});
        if (res.code == '200') {
          let message = '审批流关闭';
          this.$message.success(message);
        }
      },
      async removeWorkflow(val) {
        await Api.removeWorkflow({
          workflowDefinitionId: val.row.workflowDefinitionId,
        }).then((res) => {
          if (res.code == "200") {
            // if(!this.tableData.length){
            //   this.flag = false;
            // }
            this.$message.success("删除成功!");
            this.getWorkflowList();
          }
        });
      },

      // 删除审批流程
      handleDeleteOk(val){
        this.$confirm("该审批流程将被删除，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.removeWorkflow(val);
          })
          .catch(() => {
            this.$message.info("已取消删除");
          });
      },
  
      // 查询审批流
      getWorkflowList () {
        let params = {
          workflowDefinitionName: this.query.workflowDefinitionName,
          createUserName: this.query.createUserName,
          pageSize: this.productTagPage.pageSize,
          pageNum: this.productTagPage.pageNum,
        };
        Api.pageWorkflow(params).then((res) => {
          this.productTagPage.pageTotal = res.data.total;
          this.tableData = res.data.records;
        //   this.queryApprovalProcessSwitch();
          this.$setStore("getWorkflowListTableData", this.tableData);
        });
      },
  
      // table button
      handleButton (val) {
        switch (val.methods) {
          case "handleEdit":
            this.handleEdit(val);
            break;
          case "handleDelete":
            this.handleDelete(val);
            break;
        }
      },
  
      // 分页
      handleSizeChange (val) {
        this.productTagPage.pageSize = val;
        this.productTagPage.pageNum = 1
        this.getWorkflowList();
      },
      handleCurrentChange (val) {
        this.productTagPage.pageNum = val;
        this.getWorkflowList();
      },
  
      // 审批流编辑
      handleEdit (val) {
        this.$setStore("editConfirmWorkFlowSkusList", null);
        this.$setStore("editWorkflowDefinitionName", null);
        this.$setStore("editWorkFlowSkusList", null);
        this.$setStore("editTableData", null);
        this.$setStore("editConfirmWorkFlowSkusList", null);
        this.$setStore("workflowDefinitionId", val.row.workflowDefinitionId);
        this.$setStore("workflowDefinitionName", val.row.workflowDefinitionName);
        this.$router.push({
          name: "orderApproveEdit",
          params: {
            path: "/orderApproveEdit",
            workflowDefinitionId: val.row.workflowDefinitionId,
          },
        });
      },
      goToUrl (url) {
        this.$setStore("createName", null);
        this.$setStore("createPurchaseAuditPath", { path: "purchaseAudit" });
        this.$setStore("workflowDefinitionName", "");
        this.$setStore("workFlowSkusList", null);
        this.$router.push({ path: url });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .pagination {
    text-align: right;
  }
  </style>
  